import React         from 'react';
import CSSModules    from 'react-css-modules';

import style from './style.scss';

import InputGroup  from '../InputGroup';
import Label       from '../Label';
import InlineError from '../InlineError';
import PriceInput  from '../PriceInput';

class PriceInputs extends React.Component {

    render() {

        return (
            <div styleName="prices-container">

                <InputGroup styleName="price-group">

                    <Label isRequired="true">Private Delegate Price</Label>

                    <PriceInput className={ style['price-input'] } { ...this.props.privatePrice } errors={ this.props.privatePrice.error } />

                    <InlineError errors={ this.props.privatePrice.error } />

                </InputGroup>

                <InputGroup styleName="price-group">

                    <Label isRequired="true">Public Delegate Price</Label>

                    <PriceInput className={ style['price-input'] } { ...this.props.publicPrice } errors={ this.props.publicPrice.error } />

                    <InlineError errors={ this.props.publicPrice.error } />

                </InputGroup>

            </div>
        );
    }
}

export default CSSModules(PriceInputs, style);


// WEBPACK FOOTER //
// ./components/PriceInputs/index.js